module.exports = __webpack_public_path__ + "img/tasks-reviews-icon.ae75a8ec.svg";